/**
 * Portal Layout Component
 * TASK-361: Document Management & Compliance System
 *
 * Consistent layout wrapper for the public upload portal.
 * Extracted from UploadPortalPage for reusability.
 */

import React from 'react';
import { Shield } from 'lucide-react';

interface PortalLayoutProps {
  children: React.ReactNode;
}

const PortalLayout: React.FC<PortalLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* Header */}
      <header className="bg-[#002B45] py-4 px-6">
        <div className="max-w-lg mx-auto flex items-center gap-3">
          <Shield className="w-6 h-6 text-white" />
          <span className="text-white font-semibold">Secure Document Upload</span>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-lg bg-white rounded-xl shadow-lg p-6 sm:p-8">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="py-4 px-6 text-center">
        <p className="text-xs text-gray-500">
          Protected by secure encryption. Your documents are safe with us.
        </p>
      </footer>
    </div>
  );
};

export default PortalLayout;
